export default __webpack_public_path__ + "static/media/refresh.fce82c41.svg";